export const FETCH_ADS_CAMPAIGNS = 'fetchAdsCampaigns';
export const FETCH_CAMPAIGN_INFO = 'fetchCampaignInfo';
export const FETCH_CAMPAIGN_ADS = 'fetchCampaignAds';
export const FETCH_ADS_PRODUCT_INFO = 'fetchAdsProductInfo';
